import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { CommentaryProvider } from "@/context/CommentaryContext";
import { RouteMetadata } from "@/components/RouteMetadata";
import Home from "@/pages/Home";
import Commitments from "@/pages/Commitments";
import OnLeadership from "@/pages/OnLeadership";
import CoachingPairs from "@/pages/CoachingPairs";
import About from "@/pages/About";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SiteLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <CommentaryProvider>
        <BrowserRouter>
          <ScrollToTop />
          <RouteMetadata />
          <Routes>
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/method" element={<SiteLayout><Commitments /></SiteLayout>} />
            <Route path="/on-leadership" element={<SiteLayout><OnLeadership /></SiteLayout>} />
            <Route path="/coaching-pairs" element={<SiteLayout><CoachingPairs /></SiteLayout>} />
            <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CommentaryProvider>
    </div>
  );
}

export default App;
